<ng-container *ngIf="status === 'loading'; else graphContent">
  <sh-spinner class="image-loader" size="l"></sh-spinner>
</ng-container>

<ng-template #graphContent>
  <ng-container *ngIf="status === 'error'">
    <div>{{ 'cooling.graph.loadingError' | translate }}</div>
  </ng-container>

  <div class="graph-container" *ngIf="config">
    <ng-container *ngIf="hasGraphData(config); else noDataTemplate">
      <app-cooling-graph
        [config]="config"
        [dateFormat]="dateFormat"
      ></app-cooling-graph>
    </ng-container>

    <ng-template #noDataTemplate>
      <div class="graph-no-data">
        {{ 'cooling.graph.noDataForSelectedDates' | translate }}
      </div>
    </ng-template>
  </div>
</ng-template>
